import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { IService, IPageContent, IServiceCategory } from "app/api/types";
import {
  getServices,
  addService,
  delService,
  editService
} from "app/api/redux/Services/actions";
import { getServiceCategories } from "app/api/redux/ServiceCategories/actions";
import {
  getPageContentById,
  editPageContent,
  addPageContent,
  delPageContent
} from "app/api/redux/PageContent/actions";
import ServiceList from "app/components/ServiceList";
import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";

interface IProps extends RouteComponentProps<{ id: string }> {
  serviceCategoriesList: IServiceCategory[];
  serviceList: IService[];
  isLoading: boolean;
  getServices: () => Promise<AxiosResponse>;
  addService: (data: IService) => Promise<IService>;
  delService: (email: IService["id"]) => Promise<AxiosResponse>;
  editService: (data: IService) => Promise<IService>;
  getPageContentById: (id: string) => Promise<[IPageContent]>;
  getServiceCategories: () => Promise<AxiosResponse>;
  addPageContent: (data: IPageContent) => Promise<AxiosResponse>;
  delPageContent: (id: IPageContent["pageId"]) => Promise<AxiosResponse>;
  editPageContent: (data: IPageContent) => Promise<AxiosResponse>;
}

class ServicesPage extends React.Component<IProps> {
  componentDidMount() {
    this.props.getServiceCategories().catch(err => {
      console.log(err);
    });
    this.props.getServices().catch(err => {
      console.log(err);
      this.props.history.push("/404");
    });
  }

  render() {
    return (
      <LayoutUser>
        <ServiceList
          serviceCategoriesList={this.props.serviceCategoriesList}
          serviceList={this.props.serviceList}
          isLoading={this.props.isLoading}
          addService={this.props.addService}
          delService={this.props.delService}
          editService={this.props.editService}
          getServices={this.props.getServices}
          getPageContentById={this.props.getPageContentById}
          editPageContent={this.props.editPageContent}
          addPageContent={this.props.addPageContent}
          delPageContent={this.props.delPageContent}
        />
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    serviceCategoriesList: state.serviceCategories.serviceCategoriesList,
    serviceList: state.services.serviceList,
    isLoading: state.services.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getServices,
    addService,
    delService,
    editService,
    getServiceCategories,
    getPageContentById,
    editPageContent,
    addPageContent,
    delPageContent
  })(ServicesPage)
);
